if (!customElements.get("header-account")) {
  class HeaderAccount extends HTMLElement {
    constructor() {
      super();

      this.dropdown = this.querySelector(".header-account__dropdown");
      this.addEventListener("click", this.toggleDropdown.bind(this));
    }

    connectedCallback() {
      // Close dropdown when clicking outside
      document.addEventListener("click", (event) => {
        if (!this.contains(event.target)) {
          this.closeDropdown();
        }
      });
    }

    toggleDropdown(event) {
      // Don't prevent default if clicking on a link
      if (event.target.tagName === "A") {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (!this.dropdown) return;

      if (this.dropdown.classList.contains("active")) {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    }

    openDropdown() {
      if (!this.dropdown) return;
      this.dropdown.classList.add("active");
    }

    closeDropdown() {
      if (!this.dropdown) return;
      this.dropdown.classList.remove("active");
    }
  }

  customElements.define("header-account", HeaderAccount);
}
